import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CurrencyExchange = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div>
      <div className="px-6 md:px-[4.5rem] py-12 pt-[7rem] md:pt-[9rem] bg-[#DC143C] md:flex justify-between items-center gap-40">
        <div className="md:w-1/2">
          <h2 className="text-[#FFF] font-[Figtree] text-[0.75rem] md:text-[1rem] font-medium leading-[2.375rem] tracking-[0.26rem] text-center md:text-left uppercase">
            currency exchange
          </h2>
          <h2 className="text-[#FFF] font-[Figtree] text-[2.375rem] md:text-[2.875rem] font-medium leading-[3.0625rem] md:leading-[4.5625rem] text-center md:text-left tracking-[-0.115rem]">
            Unlock the Best Currency Exchange Rates Near You with{" "}
            <span className="font-extrabold">nimo!</span>
          </h2>
          <div className="w-full md:w-2/3 flex items-center border border-[rgba(213,213,213,0.46)] rounded-[0.3125rem] p-2 space-x-2 mt-7">
            <input
              type="text"
              placeholder="Enter Pin Code"
              className="bg-transparent text-white placeholder-white px-4 md:py-3 outline-none w-full text-[0.75rem] font-semibold leading-[1.25rem] tracking-[-0.03rem] font-[Figtree]"
            />
            <button class="bg-white text-[#E11740] px-[1.2rem] md:px-[1.62rem] py-[0.44rem] md:py-3 rounded-sm font-normal text-[0.75rem] font-[Figtree] leading-[1.25rem] tracking-[-0.03rem]">
              Submit
            </button>
          </div>
          <h2 className="text-[rgba(255,255,255,0.70)] font-[Figtree] text-[0.75rem] font-medium text-center md:text-left leading-[1.125rem] tracking-[-0.015rem] mt-3">
            Enter your PIN code and discover unbeatable rates for your currency
            needs in seconds.
          </h2>
        </div>
        <div className="md:w-1/2 flex justify-end">
          <img
            src="/assets/CurrencyExchangeLeftImg.svg"
            alt="CurrencyExchangeLeft"
          />
        </div>
      </div>

      <div
        className="mt-7 md:mt-12 md:px-[4.5rem] px-6 mb-12 bg-cover bg-center relative min-h-auto overflow-hidden inset-0  md:mx-[4.5rem]"
        style={{ backgroundImage: "url(/assets/CurrencyExchange2Block.svg)" }}
      >
        <div className="px-7 pt-8 md:px-24 md:pt-16 flex flex-col-reverse md:flex-row relative items-start">
          {/* Left Section - Cards with Scroll */}
          <div className="md:w-1/2 h-[27rem] md:h-[43rem] overflow-y-scroll scrollbar-hide relative">
            {[
              {
                img: "/assets/BestRatesIcon.png",
                title: "Best Rates in Your Area",
                text: "Instantly compare rates from trusted providers in your region by simply entering your PIN code.",
              },
              {
                img: "/assets/ConvenienceIcon.png",
                title: "Convenience Redefined",
                text: "Experience a hassle-free currency exchange process with the best rates at your fingertips.",
              },
              {
                img: "/assets/Real-TimeIcon.png",
                title: "Real-Time Updates",
                text: "Stay informed with real-time updates on the best exchange rates available.",
              },
            ].map((card, index) => (
              <div
                key={index}
                className="bg-gradient-to-b from-[#FFEFF2] to-[#FFD1DA] w-full md:w-[20.5625rem] rounded-[1.6875rem] px-[2.17rem] py-[2.17rem] md:px-[2.69rem] md:py-7 mb-4 md:mb-6"
              >
                <img src={card.img} alt={card.title} />
                <h2 className="text-[#BD4057] font-[Figtree] text-[0.89644rem] md:text-[2.0625rem] font-extrabold leading-[2.375rem] tracking-[0.04125rem] md:my-4">
                  {card.title}
                </h2>
                <p className="text-[#5E2C35] font-[Figtree] text-[0.75rem] md:text-[1rem] font-normal leading-[1.44081rem] tracking-[0.02rem]">
                  {card.text}
                </p>
              </div>
            ))}
            <div className="absolute bottom-0 left-0 w-full h-[3.125rem]"></div>
          </div>

          {/* Right Section - Text and Button */}
          <div className="md:w-1/2">
            <div className="md:w-[83%]">
              <h2 className="text-[#1D1D1D] font-[Figtree] text-[0.75rem] md:text-[1rem] font-medium leading-[2.375rem] tracking-[0.13rem] md:tracking-[0.26rem] text-center md:text-left uppercase">
                currency exchange
              </h2>
              <h2 className="text-[#1D1D1D] font-[Figtree] text-[1.1875rem] md:text-[2.875rem] font-medium leading-[1.5rem] md:leading-[4.5625rem] text-center md:text-left tracking-[-0.0475rem] md:tracking-[-0.115rem]">
                Unlock the Best Currency Exchange Rates Near You with{" "}
                <span className="text-[#E11740] font-extrabold">nimo! </span>
              </h2>
              <div className="flex justify-center md:justify-start mt-5 md:mt-10 mb-8 md:mb-0">
                <button className="bg-[#DC143C] py-3 px-6 md:py-[1.25rem] md:px-[2.3125rem] rounded-[2.8125rem] text-[#FCF7F8] font-[Figtree] text-[0.75rem] md:text-[1.5rem] font-medium leading-5 tracking-[-.06rem]">
                  Know More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="pl-6 md:pl-[4.5rem] my-12">
        <h2 className="text-[#1D1D1D] font-[Figtree] text-[1.79031rem] md:text-[2.3125rem] font-normal leading-[3.875rem]">
          How It <span className="text-[#DC143C] font-extrabold">Works</span>
        </h2>
        <div className="flex flex-col-reverse md:flex-row">
          <div className="md:w-1/2 grid grid-cols-2 gap-x-8 md:gap-x-20 gap-y-8  mt-4 md:mt-12 pr-6">
            <div>
              <img src="/assets/EnterPinIcon.png" alt="EnterPinIcon" />
              <h2 className="text-[#1D1D1D] font-[Figtree] text-[0.75rem] md:text-[1.18394rem] font-extrabold leading-[1.83706rem] tracking-[-0.02075rem] md:my-4">
                Enter Your PIN Code
              </h2>
              <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.03594rem] font-normal leading-[1.03375rem] md:leading-[1.70581rem] tracking-[-0.02075rem]">
                Provide your location to find the best exchange rates near you.
              </p>
            </div>
            <div>
              <img src="/assets/BookIcon.png" alt="BookIcon" />
              <h2 className="text-[#1D1D1D] font-[Figtree] text-[0.75rem] md:text-[1.18394rem] font-extrabold leading-[1.83706rem] tracking-[-0.02075rem] md:my-4">
                Book Instantly
              </h2>
              <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.03594rem]  font-normal leading-[1.03375rem] md:leading-[1.70581rem] tracking-[-0.02075rem]">
                Lock in your preferred rate and complete your exchange with
                ease.
              </p>
            </div>
            <div>
              <img src="/assets/CompareIcon.png" alt="CompareIcon" />
              <h2 className="text-[#1D1D1D] font-[Figtree] text-[0.75rem] md:text-[1.18394rem] font-extrabold leading-[1.83706rem] tracking-[-0.02075rem] md:my-4">
                Compare Rates
              </h2>
              <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.03594rem]  font-normal leading-[1.03375rem] md:leading-[1.70581rem] tracking-[-0.02075rem]">
                Browse real-time rates from trusted providers in your area.
              </p>
            </div>
            <div>
              <img src="/assets/PickUpIcon.png" alt="PickUpIcon" />
              <h2 className="text-[#1D1D1D] font-[Figtree] text-[0.75rem] md:text-[1.18394rem] font-extrabold leading-[1.83706rem] tracking-[-0.02075rem] md:my-4">
                Pick Up or Deliver
              </h2>
              <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.03594rem]  font-normal leading-[1.03375rem] md:leading-[1.70581rem] tracking-[-0.02075rem]">
                Choose to collect your currency at a local partner location or
                opt for doorstep delivery.
              </p>
            </div>
          </div>
          <div className="md:w-1/2 hidden md:flex justify-end">
            <img
              src="/assets/HowItsLeftImg.png"
              alt="HowItsLeftImg"
              className="h-[29.70331rem] md:h-[42.29825rem]"
            />
          </div>
        </div>
      </div>

      <div className="md:flex items-center px-6 md:px-[4.5rem] mt-16">
        {/* <div className="md:w-[30%] min-[1700px]:w-[25%]">
          <h2 className="text-[#1D1D1D] text-[1.79031rem] md:text-[2.3125rem] text-center md:text-left font-normal leading-[2.12288rem] md:leading-[3.875rem] mb-5 md:mb-9">
            Frequently Asked{" "}
            <span className="text-[#DC143C] font-bold">Questions</span>
          </h2>
          <div className="flex justify-center md:justify-start">
            <Link to={"/faq"}>
            <button className="bg-[#DC143C] py-3 px-[1.375rem] rounded-lg text-white font-[Figtree] text-[0.75rem] md:text-[1.25rem] font-semibold leading-5 tracking-[-.06rem]">
              View more
            </button>
            </Link>
          </div>
        </div> */}
        {/* <div className="md:w-[70%] min-[1700px]:w-[25%]">
          Collapsible FAQ Items
          {[
            {
              question: "How do I apply for a Nimo Forex Card?",
              answer:
                "You can apply for a Nimo Forex Card through our mobile app or website. Simply sign up, load funds, and get started. Virtual cards are available instantly, and physical cards can be delivered to your doorstep.",
            },
            {
              question: "What currencies can I load on the card?",
              answer:
                "Nimo Forex Cards support all major international currencies, including USD, EUR, GBP, AUD, CAD, SGD, AED, and many more. Check the app for the full list.",
            },
            {
              question: "Can I lock in exchange rates while loading my card?",
              answer:
                "Yes! With Nimo Forex Cards, you can lock in real-time exchange rates while loading funds, protecting you from currency fluctuations.",
            },
            {
              question: "Where can I use my Nimo Forex Card?",
              answer:
                "You can use your card anywhere in the world where Visa/Mastercard is accepted, including ATMs, retail stores, and online platforms.",
            },
            {
              question: "Can I withdraw cash from ATMs with my Forex Card?",
              answer:
                "Yes! You can withdraw local currency from ATMs worldwide. Many ATMs are fee-free when you use your Nimo Forex Card.",
            },
            {
              question: "How can I contact support for assistance?",
              answer:
                "You can reach our customer support team 24/7 through the Nimo app, email, or hotline for any questions or issues.",
            },
          ].map((faq, index) => (
            <div
              key={index}
              className="border p-6 rounded-lg border-[#DEDEDE] text-left mt-[1.12rem] cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center">
                <h3
                  className={`text-[0.75rem] md:text-[1.25rem] leading-normal text-[#1D1D1D] font-[Figtree] tracking-tight 
                                ${
                                  openIndex === index
                                    ? "font-bold"
                                    : "font-medium"
                                }`}
                >
                  {faq.question}
                </h3>
                <span className="text-xl font-bold">
                  {openIndex === index ? (
                    <img
                      src="/assets/UpArrow.png"
                      alt="Collapse"
                      className="w-[0.8125rem] h-[0.5125rem]"
                    />
                  ) : (
                    <img
                      src="/assets/DownArrow.png"
                      alt="Expand"
                      className="w-[0.8125rem] h-[0.5125rem]"
                    />
                  )}
                </span>
              </div>
              {openIndex === index && (
                <p className="text-[#2F2A35] text-[0.625rem] md:text-[0.875rem] font-normal mt-2 leading-[1.34413rem] md:leading-[1.6875rem]">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default CurrencyExchange;
